import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { PRIVACY_POLICY_LAST_UPDATED, PRIVACY_POLICY_MARKDOWN } from "@/lib/privacyPolicy";
import { LegalMarkdown, stripLeadingTitle } from "@/components/legal/LegalMarkdown";

export const PrivacyPolicyDialog = ({ open, onOpenChange, language = "es" }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="notranslate max-w-3xl gap-0 overflow-hidden p-0"
        closeButtonTestId="signup-privacy-close-button"
        data-testid="signup-privacy-dialog"
        lang={language}
        translate="no"
      >
        <DialogHeader className="border-b border-border bg-card px-6 pb-4 pt-6">
          <DialogTitle data-testid="signup-privacy-dialog-title">
            {language === "es" ? "Política de Privacidad de Voxara" : "Voxara Privacy Policy"}
          </DialogTitle>
          <DialogDescription data-testid="signup-privacy-dialog-description">
            {language === "es" ? `Última actualización: ${PRIVACY_POLICY_LAST_UPDATED}` : `Last updated: ${PRIVACY_POLICY_LAST_UPDATED}`}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="h-[55vh] px-6 py-5" data-testid="signup-privacy-scroll-area">
          <div className="pr-4" data-testid="signup-privacy-content">
            <LegalMarkdown markdown={stripLeadingTitle(PRIVACY_POLICY_MARKDOWN)} />
          </div>
        </ScrollArea>

        <DialogFooter className="border-t border-border bg-muted/20 px-6 py-4 sm:justify-between sm:space-x-0">
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} data-testid="signup-privacy-close-action-button" translate="no">
            {language === "es" ? "Cerrar" : "Close"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};